// App.jsx
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import Home from "./pages/Home";
import UseCases from "./pages/UseCases";
import Demo from "./pages/Demo";
import Pricing from "./pages/Pricing";
import Learning from "./pages/Learning";
import About from "./pages/About";
import ModulePointOfSale from "./pages/modules/ModulePointOfSale";
import ModuleSales from "./pages/modules/ModuleSales";
import ModuleECommerce from "./pages/modules/ModuleECommerce";
import ModuleInventoryStock from "./pages/modules/ModuleInventoryStock";
import ModuleLogistics from "./pages/modules/ModuleLogistics";
import ModuleFinance from "./pages/modules/ModuleFinance";
import ModuleCRM from "./pages/modules/ModuleCRM";
import ModuleHumanResources from "./pages/modules/ModuleHumanResources";
import ModuleProcurement from "./pages/modules/ModuleProcurement";
import ModuleProjectManagement from "./pages/modules/ModuleProjectManagement";
import ModuleManufacturing from "./pages/modules/ModuleManufacturing";
import ModuleBIReporting from "./pages/modules/ModuleBI";
import ModuleAssetsManagement from "./pages/modules/ModuleAssets";
import IndustryRetail from "./pages/industries/IndustryRetail";
import IndustryManufacturing from "./pages/industries/IndustryManufacturing";
import IndustryHealthcare from "./pages/industries/IndustryHealthcare";
import IndustryConstruction from "./pages/industries/IndustryConstruction";
import IndustryEducation from "./pages/industries/IndustryEducation";
import IndustryLogistics from "./pages/industries/IndustryLogistics";



import NotFound from "./pages/NotFound";
import Products from "./pages/Products";

function App() {
  const { i18n } = useTranslation();


  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/use-cases" element={<UseCases />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/learning" element={<Learning />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />



          <Route path="/modules/pos" element={<ModulePointOfSale />} />
          <Route path="/modules/sales" element={<ModuleSales />} />
          <Route path="/modules/ecommerce" element={<ModuleECommerce />} />
          <Route path="/modules/inventory-stock" element={<ModuleInventoryStock />} />
          <Route path="/modules/logistics" element={<ModuleLogistics />} />
          <Route path="/modules/finance" element={<ModuleFinance />} />
          <Route path="/modules/crm" element={<ModuleCRM />} />
          <Route path="/modules/human-resources" element={<ModuleHumanResources />} />
          <Route path="/modules/procurement" element={<ModuleProcurement />} />
          <Route path="/modules/project-management" element={<ModuleProjectManagement />} />
          <Route path="/modules/manufacturing-production" element={<ModuleManufacturing />} />
          <Route path="/modules/bi-reporting" element={<ModuleBIReporting />} />
          <Route path="/modules/assets-management" element={<ModuleAssetsManagement />} />
          <Route path="/industries/retail" element={<IndustryRetail />} />
          <Route path="/industries/manufacturing" element={<IndustryManufacturing />} />
          <Route path="/industries/healthcare" element={<IndustryHealthcare />} />
          <Route path="/industries/construction" element={<IndustryConstruction />} />
          <Route path="/industries/education" element={<IndustryEducation />} />
          <Route path="/industries/logistics" element={<IndustryLogistics />} />


          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;